import { useCallback, useRef } from "react";

const useAssinar = ({ setGuardClient }) => {
  const jaEnviouPayload = useRef(false);

  const assinaturaHandler = useCallback(
    (safePayload) => {
      if (jaEnviouPayload.current) {
        console.warn("Assinatura já foi enviada. Ignorando reenvio automático.");
        return;
      }

      jaEnviouPayload.current = true;
      setGuardClient.assinar(safePayload);
    },
    [setGuardClient],
  );

  return {
    assinaturaHandler,
    resetarEnvio: () => {
      jaEnviouPayload.current = false;
    },
  };
};

export default useAssinar;
